export default "__VITE_ASSET__199d4a6b__"